var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.24 2H11.3458C9.58159 1.99999 8.18418 1.99997 7.09054 2.1476C5.96501 2.29953 5.05402 2.61964 4.33559 3.34096C3.61717 4.06227 3.29833 4.97692 3.14701 6.10697C2.99997 7.205 2.99999 8.60802 3 10.3793V16.2169C3 17.725 3.91995 19.0174 5.22717 19.5592C5.15989 18.6498 5.15994 17.3737 5.16 16.312V11.3976V11.3024C5.15993 10.0207 5.15986 8.91644 5.27828 8.03211C5.40519 7.08438 5.69139 6.17592 6.4253 5.43906C7.15921 4.70219 8.06404 4.41485 9.00798 4.28743C9.88877 4.16854 10.9887 4.1686 12.2652 4.16867L12.36 4.16868H15.24L15.3348 4.16867C16.6113 4.1686 17.7088 4.16854 18.5896 4.28743C18.0627 2.94779 16.7616 2 15.24 2Z",
    fill: "#333D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60059 11.3974C6.60059 8.67119 6.60059 7.3081 7.44412 6.46118C8.28765 5.61426 9.6453 5.61426 12.3606 5.61426H15.2406C17.9559 5.61426 19.3135 5.61426 20.1571 6.46118C21.0006 7.3081 21.0006 8.6712 21.0006 11.3974V16.2167C21.0006 18.9429 21.0006 20.306 20.1571 21.1529C19.3135 21.9998 17.9559 21.9998 15.2406 21.9998H12.3606C9.6453 21.9998 8.28765 21.9998 7.44412 21.1529C6.60059 20.306 6.60059 18.9429 6.60059 16.2167V11.3974Z",
    fill: "#333D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.c3d753050cfbf3d1472692cd3eaa4645.svg";
export { ForwardRef as ReactComponent };